<template>
  <div class="rong-main">
    <PersonList></PersonList>
    <div class="rong-right">
      <HistoryDate></HistoryDate>

      <div class="nomessage" v-show="guang.nomessage">
        <img src="../../assets/image/nomessage.png" />
        <span>{{lan.c_nohistory}}</span>
      </div>
      <div v-show="!guang.nomessage">
        <HistoryContent></HistoryContent>
        <HistoryPage></HistoryPage>
      </div>
    </div>
  </div>
</template>
<script>
import PersonList from "./PersonList";
import HistoryDate from "./HistoryDate";
import HistoryContent from "./HistoryContent";
import HistoryPage from "./HistoryPage";
import { mapState, mapGetters } from "vuex";
export default {
  name: "index",
  data() {
    return {};
  },
  computed: {
    ...mapState(["guang"]),
    ...mapGetters({lan:'common/lan'})
  },
  components: {
    PersonList,
    HistoryDate,
    HistoryContent,
    HistoryPage
  }
};
</script>
<style lang="scss" scoped>
.rong-main {
  display: flex;
  padding-top: 41px;
  // padding-left: 30px;
  // width: 100%;
  .rong-right {
    // display: flex;
    // flex-direction:column;
    padding-left: 80px;
    width: calc(100% - 255px);
    .nomessage {
      display: flex;
      // width: 100%;
      width: 200px;
      height: 200px;
      flex-direction:column;

      align-items: center;
      margin-left: 230px;
      margin-top: 162px;
      font-size: 13px;
      font-family: PingFangSC;
      color: rgba(136, 136, 136, 1);
      img {
        display: block;
        width: 4.18rem;
        height: 4.06rem;
        margin-bottom: 15px;
      }
      span {
        // margin-left: 6px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/guang/index.vue